import type { SeoBlockSection } from "@/data/seo-pages";
import { Container } from "@/components/ui/Container";

interface SeoTextBlockV2Props {
  sections: SeoBlockSection[];
}

export function SeoTextBlockV2({ sections }: SeoTextBlockV2Props) {
  return (
    <section
      className="flex w-full flex-col items-center py-20 max-tablet:py-14"
      style={{
        background: "linear-gradient(180deg, #FFFFFF 0%, var(--brand-primary-tint) 20%, var(--brand-primary-tint) 80%, #FFFFFF 100%)",
      }}
    >
      <Container className="flex flex-col items-center">
      <div className="w-full flex flex-col gap-[40px]">
        {sections.map((section) => (
          <div key={section.h2} className="flex flex-col gap-[12px]">
            <h2 className="text-[28px] leading-[36px] font-bold text-[#1A1D1F] pb-[8px] max-tablet:text-[22px] max-tablet:leading-[30px]">
              {section.h2}
            </h2>
            {section.paragraphs?.map((text, j) => (
              <p
                key={j}
                className="text-[18px] leading-[1.7] text-[#4A5568] font-medium max-tablet:text-[16px]"
              >
                {text}
              </p>
            ))}
            {section.list && section.list.length > 0 && (
              <ul className="list-disc pl-6 flex flex-col gap-[4px]">
                {section.list.map((item, j) => (
                  <li
                    key={j}
                    className="text-[18px] leading-[1.7] text-[#4A5568] font-medium max-tablet:text-[16px]"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      </Container>
    </section>
  );
}
